import { ga } from 'js/analytics/adapters'

export const trackErrorMessage = ({
  type: error_type,
  code: error_code,
  category: error_category,
}) => {
  ga.track('Error', {
    'Error Code': error_code,
    'Error Type': error_type,
    'Error Category': error_category,
  })
}
